// extracted by mini-css-extract-plugin
export default {"header":"KV1Z1","header__title":"c2ZoW"};